/* @flow */
import * as React from 'react';
import Modal from 'react-modal';

import Group from 'entities/Group';
import GroupSelectionDialog from 'groups/components/GroupSelectionDialog.jsx';
import GroupStore from 'groups/stores/GroupStore';
import UsersInviteModal from 'users/components/UsersInviteModal';

type Props = {
  onRequestHide: () => any,
};

type State = {
  isInviteModalOpened: boolean,
  group?: ?Group,
};
export class GroupSelectToInviteDialog extends React.Component<Props, State> {
  static defaultProps = {
    onRequestHide: () => {},
  };

  state: State = {
    isInviteModalOpened: false,
  };

  handleGroupSelect = (group: Group) => {
    this.setState({ isInviteModalOpened: true, group });
  };

  render() {
    const groups = GroupStore.getInvitableGroups();
    const { group, isInviteModalOpened } = this.state;
    return (
      <React.Fragment>
        <Modal isOpen={isInviteModalOpened}>
          <UsersInviteModal group={group} onRequestHide={this.props.onRequestHide} />
        </Modal>
        <GroupSelectionDialog
          title="Select a class"
          groups={groups}
          onSelect={this.handleGroupSelect}
          onRequestHide={this.props.onRequestHide}
        />
      </React.Fragment>
    );
  }
}

export default GroupSelectToInviteDialog;
